<div class="card">
	<div class="card-header">
		View Decryption Key
	</div>
	<div class="card-body" *ngIf="!decryptionKey || decryptionKey.success === false">
		<form (ngSubmit)="onSubmit()" #passwordForm="ngForm">
			<div class="mb-3">
				<label for="agentPassword" class="form-label">
					Enter Password to View the Decryption Key
				</label>
				<input
					id="agentPassword"
					name="agentPassword"
					type="password"
					class="form-control"
					placeholder="Enter your password"
					[(ngModel)]="agentPassword"
					required
				/>
			</div>

			<div *ngIf="decryptionKey && decryptionKey.success == false" class="mb-3">
				<small class="text-danger">
					Password is incorrect.
				</small>
			</div>

			<div class="text-end">
				<button type="submit" class="btn btn-primary" [disabled]="passwordForm.invalid">
					Submit
				</button>
			</div>
		</form>
	</div>
<div class="card-body" *ngIf="decryptionKey && decryptionKey.success === true">
	<div class="alert alert-info d-flex justify-content-between align-items-center">
		<span>Decryption Key: {{ decryptionKey.decryptionKey }}</span>
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm"
			(click)="copyToClipboard(decryptionKey.decryptionKey!)"
			title="Copy to clipboard">
			<fa-icon [icon]="faCopy"></fa-icon>
		</button>
	</div>
	<div *ngIf="copied" class="text-success">Copied!</div>
</div>
</div>
